<template>
    <div>      
         <v-autocomplete v-model="sendedCollection"
                        :rules="[rules.required]"                     
                        :items="collections"   
                        label="Selecione as Coleçoes"
                        :multiple="this.multiple"
                        item-text="nome"
                        item-value="id"
                        :readonly="this.readonly"
                        :disabled="this.readonly"
                        @blur="sendSelectData()"
        ></v-autocomplete>     
    </div>    
</template>

<script>

export default {
    props: ['collection','multiple','readonly'],
    data() {
        return {
            collections: [],
            sendedCollection: this.collection,
            rules: {
                required: value => !!value || 'Campo Obrigatório.'
            }                   
        }
    },
    created() {
        this.collections = this.$store.getters.data.data.colecoes
    },
    methods: {
        sendSelectData() {
            this.$emit('collectionSelect', this.sendedCollection)
            console.log('emitiu o evento')
            console.log(this.sendedCollection)
        }
    }

}
</script>
